import { forwardRef } from 'react';
import { StyledModalEditableName } from './styled';

const ModalEditableName = forwardRef((props, ref) => (
  <StyledModalEditableName ref={ref} placeholder="Name" {...props} />
));

export default ModalEditableName;
